import Vue from 'vue'
import VueGmaps from 'vue-gmaps'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-themify-icons/themify-icons/themify-icons.css'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueGmaps, {
  key: 'AIzaSyBRUrhTOi1tqoFWDxfm99h_7B3GksbZkns'
});
Vue.use(VueFormWizard);
Vue.use(Buefy)

new Vue({
  render: h => h(App),
}).$mount('#app')
